import { render } from "./PlacementCompatibilityIndicator.vue?vue&type=template&id=25168b77&scoped=true"
import script from "./PlacementCompatibilityIndicator.vue?vue&type=script&lang=js"
export * from "./PlacementCompatibilityIndicator.vue?vue&type=script&lang=js"

import "./PlacementCompatibilityIndicator.vue?vue&type=style&index=0&id=25168b77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25168b77"]])

export default __exports__